import { BROADCAST_SET_DIRECTOR_CONTROLS } from '../Types';

function setDirectorControls({ key, value }) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_DIRECTOR_CONTROLS,
      payload: {
        key,
        value
      }
    };

    dispatch(action);
  };
}

export default setDirectorControls;
